import { combineReducers } from "@reduxjs/toolkit";
import ipoViewPageReducer from "./ipoViewPage";

const ipoViewReducers = combineReducers({
  ipoViewPage: ipoViewPageReducer,
});

export default ipoViewReducers;
